module.exports = __webpack_public_path__ + "img/dl_button.2d195b8d.png";